import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-select-business',
  templateUrl: './select-business.component.html',
  styleUrls: ['./select-business.component.scss']
})
export class SelectBusinessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
